/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AssignmentErrorIcon = /*#__PURE__*/ createSvgIcon(
  'AssignmentErrorIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 19.167A9.167 9.167 0 1010 .834a9.167 9.167 0 000 18.333zm-.445-8.097c.12.12.268.18.445.18s.326-.06.445-.18c.12-.12.18-.268.18-.445V6.25a.605.605 0 00-.18-.445.605.605 0 00-.445-.18.605.605 0 00-.445.18.605.605 0 00-.18.445v4.375c0 .177.06.325.18.445zm0 3.125c.12.12.268.18.445.18s.326-.06.445-.18c.12-.12.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18.605.605 0 00-.445.18.605.605 0 00-.18.445c0 .177.06.325.18.445z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AssignmentErrorIcon;
